module.exports = __webpack_public_path__ + "static/media/AggregateBackground.e4a1ca23.png";